import { render } from 'preact';
import './lib/dayjs'; // side-effect: fija el locale 'es' de dayjs (ver lib/dayjs.ts)
import { App } from './App';

// Guardarraíl de locale: uPlot (y potencialmente otras libs) hacen
// `new Intl.NumberFormat(navigator.language)` al evaluar su módulo. Si el
// navegador reporta un tag BCP-47 inválido (p. ej. "en-US@posix" en headless,
// kiosk o entornos POSIX), ese constructor lanza RangeError y tumba todas las
// páginas con charts. Saneamos ANTES de que cargue ningún chunk lazy: si el
// tag no es válido, lo sobreescribimos con el locale de la app.
try {
  new Intl.NumberFormat(navigator.language);
} catch {
  Object.defineProperty(navigator, 'language', { value: 'es-ES', configurable: true });
}

// Fuentes self-hosted (antes Google Fonts CDN: render-blocking + IP a Google,
// problemático para GDPR/AEPD). Vía @fontsource → mismo origen, cacheadas con la
// app, sin terceros. Inter Variable cubre todos los pesos en un archivo;
// Instrument Serif (display) en 400 + italic. Todas con font-display: swap.
import '@fontsource-variable/inter';
import '@fontsource/instrument-serif/400.css';
import '@fontsource/instrument-serif/400-italic.css';

// Import CSS and ensure it's injected in development
import './styles/globals.css';

if (import.meta.hot) {
  import.meta.hot.accept('./styles/globals.css', () => {
    // CSS hot reload
  });
}

// Tras un deploy, los chunks lazy con hash viejo dejan de existir en el
// servidor. La primera navegación a una página no precargada lanza este
// evento — recargamos para tomar el index.html nuevo. El guardarraíl en
// sessionStorage evita un bucle infinito si tras la recarga vuelve a fallar
// (deploy realmente roto): en ese caso el error sube al ErrorBoundary.
window.addEventListener('vite:preloadError', (event) => {
  const reloadKey = 'vite-preload-error-reloaded';
  if (sessionStorage.getItem(reloadKey)) return;
  sessionStorage.setItem(reloadKey, '1');
  event.preventDefault();
  window.location.reload();
});

// Nota: NO usamos la View Transitions API para la navegación entre rutas.
// El contenido es lazy + async (Suspense + useQuery), así que el snapshot del
// "nuevo" estado se capturaba mientras aún resolvía → la VT animaba hacia un
// snapshot vacío y luego el contenido real aparecía de golpe por encima
// (overlay en top-layer). La transición entre rutas la hace ahora un fade-in
// de opacidad al montar el contenido (RouteTransition en App.tsx + .route-fade
// en globals.css): sin overlay, sin snapshot vacío, sin solape de dos páginas.

const mount = document.getElementById('app');
if (!mount) throw new Error('Missing #app mount point');
render(<App />, mount);

// Observability (Sentry + web-vitals) cargada en chunk separado y diferida
// al post-render: no bloquea el first paint y saca ~80KB del main bundle.
// Si un error ocurre antes de que termine este import, va a console (Sentry
// no estaba listo todavía); en cuanto el chunk carga, captureError funciona
// para errores subsiguientes.
// Sin DSN ni Sentry ni web-vitals reportan nada (reportMetric exige Sentry
// listo): no merece la pena descargar el chunk (~53 KB gz con Sentry 11).
if (import.meta.env['VITE_SENTRY_DSN']) {
  void import('./lib/observability').then((m) => m.initObservability());
}
